import { ApplicationDataTextField } from '../Fields/ApplicationDataTextField';
import { ApplicationDataTextArea } from '../Fields/ApplicationDataTextArea';
import styles from './ApplicationDataCommentTabPanel.module.css';
import { useApplicationDataStore } from '../../../store/applicationDataStore';
import { Divider } from '@blueprintjs/core';
import { ApplicationDataBaseField } from '../Fields/ApplicationDataBaseField';
import { SmallTag } from '../../SmallTag';
import { UserName } from '../../UserName';
import { formatDatetime } from '../../../utils/formatDate';
import { useGetAppComment } from '@axo/shared/data-access/hooks';

interface ApplicationDataCommentTabPanelProps {
  applicationID: string;
  viewOnly?: boolean;
}

export const ApplicationDataCommentTabPanel: React.FC<
  ApplicationDataCommentTabPanelProps
> = ({ applicationID, viewOnly }) => {
  const { isEditing } = useApplicationDataStore(applicationID);
  const { data: appCommentData } = useGetAppComment(applicationID);

  return (
    <div className={styles.container}>
      {isEditing && !viewOnly ? (
        <div className={styles.editContainer}>
          <ApplicationDataTextField
            applicationID={applicationID}
            name="CommentTitle"
            label="Comment title"
            horizontal={true}
          />
          <ApplicationDataTextArea
            applicationID={applicationID}
            name="CommentBody"
            placeholder="Write your comment here..."
            horizontal={true}
            fullWidth={true}
          />
        </div>
      ) : (
        <div className={styles.viewContainer}>
          <div className={styles.viewContainerHeader}>
            <ApplicationDataTextField
              applicationID={applicationID}
              name="CommentTitle"
              label="Comment title"
              horizontal={true}
              isEditable={false}
            />
            <div className={styles.viewContainerHeaderChild}>
              <ApplicationDataBaseField
                applicationID={applicationID}
                label="Created by"
                horizontal={true}
                valueElement={
                  <SmallTag minimal icon="lock" intent="success">
                    <UserName clientID={appCommentData?.CreatedBy ?? ''} />
                  </SmallTag>
                }
              />
              <Divider />
              <ApplicationDataBaseField
                applicationID={applicationID}
                label="Created on"
                horizontal={true}
                valueElement={
                  appCommentData?.UpdatedAt
                    ? formatDatetime(appCommentData.UpdatedAt as string)
                    : '-'
                }
              />
            </div>
          </div>
          <Divider />
          <div className={styles.viewBody}>{appCommentData?.Body || '-'}</div>
        </div>
      )}
    </div>
  );
};
